import LegacySubscriptionTypeSelect from './LegacySubscriptionTypeSelect';
import SubscriptionTypeForm from './SubscriptionTypeForm';
import { jsx as _jsx } from "react/jsx-runtime";
const SubscriptionTypeSelect = props => {
  const {
    isUngatedForSubscriptionGroups,
    multi
  } = props;
  if (isUngatedForSubscriptionGroups && !multi) {
    return /*#__PURE__*/_jsx(SubscriptionTypeForm, Object.assign({}, props));
  } else {
    return /*#__PURE__*/_jsx(LegacySubscriptionTypeSelect, Object.assign({}, props));
  }
};
export default SubscriptionTypeSelect;